import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export abstract class IndicatorService {
  private announcedSource = new Subject<any>();
  private confirmedSource = new Subject<any>();

  announced$ = this.announcedSource.asObservable();
  confirmed$ = this.confirmedSource.asObservable();

  announce(data: any) {
    this.announcedSource.next(data);
  }

  confirm(data: any) {
    this.confirmedSource.next(data);
  }
}
